import { render, staticRenderFns } from "./GestorPedidosVideo.vue?vue&type=template&id=6aec4bda&scoped=true"
import script from "./GestorPedidosVideo.vue?vue&type=script&lang=js"
export * from "./GestorPedidosVideo.vue?vue&type=script&lang=js"
import style0 from "./GestorPedidosVideo.vue?vue&type=style&index=0&id=6aec4bda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aec4bda",
  null
  
)

export default component.exports